module.exports = __webpack_public_path__ + "img/maas_bg3.ef0eb8af.png";